import { CATEGORIES, GUIDES, PRODUCT_LISTS } from "./data";
import { toIsoDate } from "./seo";

/**
 * @typedef {Object} SeoRoute
 * @property {string} path      Relative URL with a leading slash and no trailing slash (root = "/").
 * @property {number} priority  Sitemap priority, 0.1–1.0.
 * @property {string|null} lastmod ISO date, or null when the content has no real date.
 */

const PRIORITY = {
  home: 1.0,
  index: 0.8,
  detail: 0.7,
  legal: 0.3,
};

/**
 * Static routes of the router, in navigation order.
 * `/about` is a primary navigation page, so it shares the section-index priority.
 */
const STATIC_ROUTES = [
  { path: "/", priority: PRIORITY.home },
  { path: "/guide", priority: PRIORITY.index },
  { path: "/categorie", priority: PRIORITY.index },
  { path: "/liste", priority: PRIORITY.index },
  { path: "/about", priority: PRIORITY.index },
  { path: "/policy", priority: PRIORITY.legal },
  { path: "/disclosure", priority: PRIORITY.legal },
  { path: "/privacy", priority: PRIORITY.legal },
  { path: "/cookie", priority: PRIORITY.legal },
  { path: "/termini", priority: PRIORITY.legal },
  { path: "/note-legali", priority: PRIORITY.legal },
];

/**
 * Every indexable URL of the site, derived from the content seed.
 * Excludes the catch-all route, query-string URLs and the /shop placeholder.
 *
 * @returns {SeoRoute[]} Deduplicated routes: static first, then dynamic in data order.
 */
export function getSeoRoutes() {
  const routes = STATIC_ROUTES.map((route) => ({ ...route, lastmod: null }));

  GUIDES.forEach((guide) => {
    routes.push({
      path: `/guida/${guide.slug}`,
      priority: PRIORITY.detail,
      lastmod: toIsoDate(guide.date),
    });
  });

  CATEGORIES.forEach((category) => {
    routes.push({
      path: `/categorie/${category.slug}`,
      priority: PRIORITY.detail,
      lastmod: null,
    });
  });

  PRODUCT_LISTS.forEach((list) => {
    routes.push({
      path: `/liste/${list.slug}`,
      priority: PRIORITY.detail,
      lastmod: null,
    });
  });

  const seen = new Set();
  return routes.filter((route) => {
    if (seen.has(route.path)) return false;
    seen.add(route.path);
    return true;
  });
}
